<template>
  <smart-banner
    :bg-color="bgColor"
    direction="row"
    :has-kicker="true"
    kicker-color="#717D96"
    kicker-weight="700"
    :kicker-align="align"
    title-color="#3b3b3b"
    title-size="h1"
    title-weight="400"
    :title-align="align"
    text-color="#43515A"
    text-size="md"
    text-weight="400"
    :text-align="align"
    :has-button="false"
    :has-image="false"
    :has-fixed-image="false"
    :center-items="false"
    :reduce-width="false"
    :has-video="false"
  >
    <template v-slot:kicker>
      <slot name="septenary-kicker" />
    </template>
    <template v-slot:title>
      <slot name="septenary-title" />
    </template>
    <template v-slot:text>
      <slot name="septenary-text" />
    </template>
  </smart-banner>
</template>

<script>
import SmartBanner from './smart-banner.vue'

export default {
  name: 'smart-banner-septenary',
  components: {
    SmartBanner,
  },
  props: {
    direction: {
      type: String,
    },
    align: {
      type: String,
    },
    titleColor: {
      type: String,
      default: '#3b3b3b',
    },
    bgColor: {
      type: String,
      default: '#FFFFFF',
    }
  },
}
</script>
